import { Component, OnInit } from '@angular/core';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { last, takeUntil } from 'rxjs/operators';
import { DashboardCountService } from '@carm/_core/dashboard-count/services/dashboard-count.service';
import { combineLatest } from 'rxjs';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { BaseComponent } from '@carm/_utils/base.component';

@Component({
  selector: 'carm-access-requests-widget',
  templateUrl: './access-requests.component.html',
  styleUrls: ['./access-requests.component.scss'],
})
export class AccessRequestsWidgetComponent extends BaseComponent implements OnInit {

  viewAllAccessRequestsUrl: string;
  viewAllEmployeeRequestsUrl: string;
  pendingEmployeeRequests: number;
  thirdPartyAccessRequests: number;
  loading = true;

  constructor(private dashboardCountService: DashboardCountService, private carmRouter: CarmRouter) {
    super();
  }

  ngOnInit(): void {

    this.viewAllEmployeeRequestsUrl = RoutesConst.EmployeeAccessMgt_ManageAccessRequests;
    this.viewAllAccessRequestsUrl = RoutesConst.BusinessAccessMgt_B2BReceivedRequests;

    this.pendingEmployeeRequests = 0;

    combineLatest([
      this.carmRouter.bn9$,
      this.carmRouter.bn15$,
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([bn9, programId]) => {

        this.loading = true;

        combineLatest([
          this.dashboardCountService.getStaffMemberAccessRequestsCount(bn9, programId),
          this.dashboardCountService.getThirdPartyAccessRequestsCount(bn9, programId)
        ])
          .pipe(takeUntil(this.destroy$), last())
          .subscribe(([staffMemberAccessRequestsCountResponse, thirdPartyAccessRequestsCountResponse]) => {
            this.loading = false;
            this.pendingEmployeeRequests = staffMemberAccessRequestsCountResponse?.recordCount || 0;
            this.thirdPartyAccessRequests = thirdPartyAccessRequestsCountResponse?.recordCount || 0;
          }, () => this.loading = false);
      },
      () => this.loading = false);
  }
}
